import script from "./OuterLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OuterLayout.vue?vue&type=script&setup=true&lang=js"

import "./OuterLayout.vue?vue&type=style&index=0&id=61ab583c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ab583c"]])

export default __exports__